import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import CommonModal from '../../../common-components/CommonModal';
import AppLoader from '../../../common-components/AppLoader';
import ChatTimeLineItem from '../../../containers/chat/components/ChatTimeLineItem';
import useSingleSessionViewHandler from '../hooks/useSingleSessionViewHandler';
import useSessionTimeline from '../hooks/useSessionTimeline';

interface SingleSessionViewProps {
  sessionId: string | null;
}

export default function SingleSessionView({ sessionId }: SingleSessionViewProps) {
  const { setSelectedSessionIsdToView } = useSingleSessionViewHandler();
  const { isLoading, messages } = useSessionTimeline(sessionId);

  const handleClose = () => {
    setSelectedSessionIsdToView(null);
  };

  return (
    <CommonModal open={Boolean(sessionId)} onClose={handleClose} title="Session Timeline" maxWidth="lg">
      <Box
        sx={{
          minHeight: 320,
          maxHeight: '70vh',
          width: '100%',
        }}
      >
        {isLoading ? (
          <Box sx={{ minHeight: 320, display: 'grid', placeItems: 'center' }}>
            <AppLoader />
          </Box>
        ) : messages.length ? (
          <Stack spacing={2} sx={{ overflowY: 'auto', maxHeight: '70vh', pr: 1 }}>
            {messages.map((message) => (
              <ChatTimeLineItem key={message._id} sender={message.sender} assistantResponse={message.message} />
            ))}
          </Stack>
        ) : (
          <Box sx={{ minHeight: 320, display: 'grid', placeItems: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              No timeline items found for this session.
            </Typography>
          </Box>
        )}
      </Box>
    </CommonModal>
  );
}
